import { axiosService } from "./axiosService";

const revenueApi = {
    getByMonth(params) {
        const url = `/revenue`;
        return axiosService.get(url, { params })
    },
    createRevenue(body) {
        const url = '/revenue';
        return axiosService.post(url, body)
    },
    updateBudget(body) {
        const url = '/budget';
        return axiosService.post(url, body)
    },
    getGrowth(body) {
        const url = `/growth`;
        return axiosService.post(url, body)
    },
    getMultiShopRevenue(params) {
        const url = `/revenue/admin/multi-shop`;
        return axiosService.get(url, { params });
    },
    saveMultiShopRevenue(body) {
        const url = `/revenue/admin/multi-shop`;
        return axiosService.post(url, body);
    },
    getMultiShopBudget(params) {
        const url = `/revenue/admin/multi-shop/budget`;
        return axiosService.get(url, { params });
    },
    processMultiShopRevenueFromUrl(body) {
        const url = `/revenue/admin/multi-shop/from-url`;
        return axiosService.post(url, body);
    },
    saveMultiShopBudget(body) {
        const url = `/revenue/admin/multi-shop/budget`;
        return axiosService.post(url, body);
    },
}

export default revenueApi;